const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const NEW_VIEW_TOTAL = 280083;
const DATA_POINT_VIEWS = 219772;

const SCALE_FACTOR = (NEW_VIEW_TOTAL / DATA_POINT_VIEWS);


module.exports.reportData = {
  info: {
    campaignName: 'VOXI Endless Challenge',
    influencerName: 'Callux, Caspar Lee and Oli White',
    reportDate: new Date('2018-04-16'),
    hasLogo: true,
    campaignHashTag: '#VOXIendlesschallenge',
    campaignSponsorHandle: '@VOXI_UK',
    campaignArchive: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/campaign-archives/voxi-oli.zip',
  },
  youtubeViews: NEW_VIEW_TOTAL,
  youtubeEngagements: 11506 * SCALE_FACTOR,
  scaleFactor: SCALE_FACTOR,
  heroData: {
    main: {
      title: 'ULTIMATE STICKER PRANK CHALLENGE',
      subTitle: `Today I pranked my friends and tried to stick things on them without them noticing!
This video is part of a sponsored collaboration with VOXI
CLICK HERE to order my exclusive SIM pack - http://www.voxi.co.uk/oliwhite`,
      videoUrl: 'https://www.youtube.com/watch?v=iPcYoXKtcgU',
      views: NEW_VIEW_TOTAL,
      engagements: 11506 * SCALE_FACTOR,
      watchTimeUKIre: 825878 * SCALE_FACTOR,
      watchTimeTotal: 1120853 * SCALE_FACTOR,
      scaleFactor: SCALE_FACTOR,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [69.7, 30.3],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [4.6, 10.5, 6.6, 4.7, 3.2, 0.4, 0.3],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [16.9, 27.7, 11.5, 7.9, 4.8, 0.5, 0.6],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 791352,
        views: 155080,
        likes: 7267,
      },
      {
        name: 'United States',
        watchTime: 84121,
        views: 16482,
        likes: 1020,
      },
      {
        name: 'Australia',
        watchTime: 49974,
        views: 8939,
        likes: 494,
      },
      {
        name: 'Ireland',
        watchTime: 34526,
        views: 7108,
        likes: 323,
      },
      {
        name: 'Canada',
        watchTime: 16542,
        views: 3062,
        likes: 170,
      },
    ],
    },
    supportingData: {
      labels: [
        'instagram',
        'instagram STORY',
        'twitter',
      ],
      datasets: [{
        data: [0, 107628, 593116],
        backgroundColor: [
          dyzioPalette.bgPink,
          dyzioPalette.bgGreen,
          dyzioPalette.blue,
        ],
        borderColor: [
          dyzioPalette.pink,
          dyzioPalette.green,
          dyzioPalette.bgBlue,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/voxi-endless-challenge-2018-oli.js